import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import CloseIcon from '@mui/icons-material/Close';

import { useNavigationStack } from '../../../context/NavigationStackContext';
import { useWindowSize } from '../../../hooks/use-window-size';
import { Paths } from '../../../shared/paths';
import { ISubscriptionPlan } from '../../../types/interfaces/subscription-plan';
import WarningNoticeBanner from '../../designe/warning-notice-banner/WarningNoticeBanner';
import ChoosePlan from '../choose-plan/ChoosePlan';
import { useStyles } from './ChoosePlanDialog.styles';

interface IChoosePlanDialogProps {
  open: boolean;
  onClose: () => void;
  variant?: 'default' | 'subscriptionLimit';
}

function ChoosePlanDialog(props: IChoosePlanDialogProps) {
  const { open, onClose, variant = 'default' } = props;
  const { mobileView } = useWindowSize();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const { navigate } = useNavigationStack();

  function onPlanSelected(plan: ISubscriptionPlan) {
    navigate(`${Paths.plan.root}?plan=${plan.id}`);
  }

  return (
    <Dialog
      fullScreen={mobileView}
      open={open}
      onClose={onClose}
      classes={{ paper: classes.choosePlanDialogWrapper }}>
      <div className={classes.choosePlanDialogHeader}>
        <CloseIcon onClick={onClose} />
      </div>
      {variant === 'subscriptionLimit' && (
        <WarningNoticeBanner
          className={classes.subscriptionLimitNotice}
          title={t('choosePlan.subscriptionLimitNoticeTitle')}>
          {t('choosePlan.subscriptionLimitNoticeDescription')}
        </WarningNoticeBanner>
      )}
      <h1 className={classes.choosePlanDialogTitle}>{t('choosePlan.title')}</h1>
      <div className={classes.choosePlanDialogContainer}>
        <ChoosePlan onPlanSelected={onPlanSelected} />
      </div>
    </Dialog>
  );
}

export default ChoosePlanDialog;
